import { Component, ContentChild, ElementRef, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'odq-navigation-step-wrapper',
    templateUrl: './navigation-step-wrapper.component.html',
    styleUrls: ['./navigation-step-wrapper.component.scss'],
    standalone: false
})
export class NavigationStepWrapperComponent {
    @Input() showPreviousStep: boolean;
    @Input() showNextStep: boolean;
    @Input() title: string;
    @Input() disableButtons: boolean;
    @Output() onPreviousStep = new EventEmitter();
    @Output() onNextStep = new EventEmitter();

    @ContentChild('content') content: ElementRef;

    nextStep() {
        this.onNextStep.emit();
    }

    previousStep() {
        this.onPreviousStep.emit();
    }
}
